module.exports = __webpack_public_path__ + "static/media/outlet_policy.1f9f521c.svg";